import { createFileRoute } from "@tanstack/react-router";
import { LiderZakupyListPage } from "@/features/contracts/lider-zakupy-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/lider-zakupy/")({
	component: LiderZakupyListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.lider-zakupy",
			location.pathname,
		);
	},
});
